import React from "react";
import {Checkbox} from "primereact/checkbox";
import {InputSwitch} from "primereact/inputswitch";
import TimeSelect from "./time-select";

export const DAYS = [
    {key: "sat", label: "شنبه"},
    {key: "sun", label: "یکشنبه"},
    {key: "mon", label: "دوشنبه"},
    {key: "tue", label: "سه‌شنبه"},
    {key: "wed", label: "چهارشنبه"},
    {key: "thu", label: "پنجشنبه"},
    {key: "fri", label: "جمعه"},
];

export default function QuietHoursSection({preference, onPreferenceChange}) {
    const enabled = Boolean(preference.quietHoursEnabled);
    const days = new Set(preference.quietHoursDays || []);
    const toggleDay = (key) => {
        const next = new Set(days);
        if (next.has(key)) next.delete(key); else next.add(key);
        onPreferenceChange({quietHoursDays: DAYS.map((day) => day.key).filter((day) => next.has(day))});
    };

    return (
        <section className="ns-card h-full">
            <div className="flex align-items-start justify-content-between gap-3">
                <div>
                    <h2 className="ns-card-title"><span className="ns-icon"><i className="pi pi-moon"/></span>ساعات بدون مزاحمت</h2>
                    <p className="ns-card-description mb-0">در این بازه Push ارسال نمی‌شود و بعد از پایان آن تحویل می‌شود؛ داخل زوفینو همه‌چیز فوراً ثبت می‌شود.</p>
                </div>
                <InputSwitch checked={enabled} onChange={(event) => onPreferenceChange({quietHoursEnabled: event.value})} aria-label="ساعات بدون مزاحمت"/>
            </div>
            <div className={`flex flex-column gap-3 mt-3 ${enabled ? "" : "opacity-50 pointer-events-none"}`}>
                <div className="flex align-items-center gap-2 flex-wrap text-xs">
                    <span className="text-600">از</span>
                    <TimeSelect value={preference.quietHoursStart || "22:00"} onChange={(quietHoursStart) => onPreferenceChange({quietHoursStart})} disabled={!enabled} ariaLabel="شروع"/>
                    <span className="text-600">تا</span>
                    <TimeSelect value={preference.quietHoursEnd || "08:00"} onChange={(quietHoursEnd) => onPreferenceChange({quietHoursEnd})} disabled={!enabled} ariaLabel="پایان"/>
                </div>
                <div className="flex flex-wrap gap-2">
                    {DAYS.map((day) => (
                        <button
                            key={day.key}
                            type="button"
                            disabled={!enabled}
                            onClick={() => toggleDay(day.key)}
                            className={`ns-chip ${days.has(day.key) ? "is-active" : ""}`}
                            aria-pressed={days.has(day.key)}
                        >
                            {day.label}
                        </button>
                    ))}
                </div>
                <label className="flex align-items-center gap-2 text-xs text-700 cursor-pointer">
                    <Checkbox checked={preference.allowCriticalDuringQuietHours !== false} onChange={(event) => onPreferenceChange({allowCriticalDuringQuietHours: event.checked})} disabled={!enabled}/>
                    اعلان‌های امنیتی حیاتی حتی در این ساعات ارسال شوند
                </label>
            </div>
        </section>
    );
}
